export function isTaxConfirmed(taxSettings: { isConfirmed?: boolean } | undefined): boolean {
  return Boolean(taxSettings?.isConfirmed);
}
